import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs, { Dayjs } from 'dayjs';
import { useDispatch } from 'react-redux';
import { setIbtHeaderLoading, updateIbtDate } from '@modules/ibt';
import { useSelector } from 'react-redux';
import { Flip, toast } from 'react-toastify';

const IBTHeader = () => {
    const dispatch = useDispatch()

    type LoadingType = 'quiz' | 'user' | 'enter' | 'submit'
    const [loading, setLoading] = useState<Record<LoadingType, boolean>>({
        quiz: false,
        user: false,
        enter: false,
        submit: false,
    })
    const ibtDate = useSelector((state) => state.ibt.ibtDate)
    const ibtHeaderLoading = useSelector((state) => state.ibt.ibtHeaderLoading)

    useEffect(() => {
        dispatch(setIbtHeaderLoading(true))

        try {
            console.log('calculate sidebar data')
            // const response = await api.get('/ibt/header-data')
        } catch (error) {
            console.log('error: ', error)
        } finally {
            setTimeout(() => {
                dispatch(setIbtHeaderLoading(false))
            }, 1500)
        }
    }, [])
    
    const updateDate = (e: Dayjs | null, dateType: 'startDate' | 'endDate') => {
        console.log('ibtDate: ', ibtDate)
        console.log(dayjs(e).unix())
        const timestamp: number = dayjs(e).unix()

        dateType == 'startDate' ? dispatch(updateIbtDate({...ibtDate, startDate: timestamp})) : dispatch(updateIbtDate({...ibtDate, endDate: timestamp}))
        /*
        if(dateType === 'startDate') {
            if(timestamp > ibtDate.endDate ) {
                console.log('시간 설정 오류')
                if(ibtDate.startDate != null) {
                    dispatch(updateIbtDate({ ...ibtDate, startDate: null }))
                }
                toast.error("시작 시간을 종료 시간보다 이후로 설정할 수 없습니다.", {
                    position: "top-center",
                    transition: Flip
                });
            } else {
                dispatch(updateIbtDate({ ...ibtDate, startDate: timestamp }))
            }
            
        } else {
            if(timestamp < ibtDate.startDate) {
                console.log('시간 설정 오류')
                dispatch(updateIbtDate({ ...ibtDate, endDate: null }))
                toast.error("종료 시간을 시작 시간보다 이전으로 설정할 수 없습니다.", {
                    position: "top-center",
                    transition: Flip
                });
            } else {
                dispatch(updateIbtDate({ ...ibtDate, endDate: timestamp }))
            }
        }
        */
        // dateType == 'startDate' ? dispatch(updateIbtDate({ startDate: timestamp })) : dispatch(updateIbtDate({ endDate: timestamp }))
    }

    const renderLoading      = (loadingType: LoadingType) => {
        if(loading[loadingType] == true) {
            return <Box id="pre-loading" />
        } else {
            return <Box id="pre-loading" />
        }
    }

    return (
        <Box id='ibt-header' className='pt-4'>
            <Box className='flex-center pl-2 pr-2 pb-4 border-bottom-1'> {/* IBT DatePicker */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        className='txt-input-padding'
                        format="YYYY-MM-DD"
                        views={['year', 'month', 'day']}
                        label="시작 일시"
                        sx={{ width: 250 }}
                        slotProps={{ textField: { size: 'small' }, field: {clearable: true, onClear: () => dispatch(updateIbtDate({ ...ibtDate, startDate: null }))} }}
                        onChange={(e: Dayjs | null) => updateDate(e, 'startDate')}
                        value={ ibtDate.startDate != null ? dayjs.unix(ibtDate.startDate) : null}
                    />
                    <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                    <DateTimePicker
                        className='txt-input-padding mr-2'
                        format="YYYY-MM-DD"
                        views={['year', 'month', 'day']}
                        label="종료 일시"
                        sx={{ width: 250 }}
                        slotProps={{ textField: { size: 'small' }, field: {clearable: true, onClear: () => dispatch(updateIbtDate({ ...ibtDate, endDate: null }))} }}
                        onChange={(e: Dayjs | null) => updateDate(e, 'endDate')}
                        value={ ibtDate.endDate != null ?  dayjs.unix(ibtDate.endDate) : null }
                    />
                </LocalizationProvider>
            </Box>

            <Box id="ibt-summary-header" className='flex-between pt-4 pr-5 pl-5 pb-4 text-align-center border-bottom-1'> {/* IBT Summary Column */}
                <Box>
                    <Box className='inner-txt-top fs-3 fw-bold'>총 등록 개수</Box>
                    <Box className='inner-txt-bottom fs-0'>
                        { ibtHeaderLoading ? <Box className='ibt-loading' /> : 192 }
                    </Box>
                    {/* { renderLoading('quiz') } */}
                </Box>
                <Box>
                    <Box className='inner-txt-top fs-3 fw-bold'>총 응시 인원</Box>
                    <Box className='inner-txt-bottom fs-0'>
                        { ibtHeaderLoading ? <Box className='ibt-loading' /> : 1002 }
                    </Box>
                    {/* { renderLoading('user') } */}
                </Box>
                <Box>
                    <Box className='inner-txt-top fs-3 fw-bold'>총 응시 시도 인원</Box>
                    <Box className='inner-txt-bottom fs-0'>
                        { ibtHeaderLoading ? <Box className='ibt-loading' /> : 992 }
                    </Box>
                    {/* { renderLoading('enter') } */}
                </Box>
                <Box>
                    <Box className='inner-txt-top fs-3 fw-bold'>총 제출 답안</Box>
                    <Box className='inner-txt-bottom fs-0'>
                        { ibtHeaderLoading ? <Box className='ibt-loading' /> : 990 }
                    </Box>
                    {/* { renderLoading('submit') } */}
                </Box>
            </Box>
        </Box>
    )
}

export default IBTHeader;